var _templateObject = _taggedTemplateLiteralLoose(['\n  &.fa.fa-angle-down {\n    color: white;\n    padding: 2px 5px;\n    font-size: 16px;\n    font-weight: 600;\n  }\n'], ['\n  &.fa.fa-angle-down {\n    color: white;\n    padding: 2px 5px;\n    font-size: 16px;\n    font-weight: 600;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  height: 80px;\n  padding: 10px;\n'], ['\n  height: 80px;\n  padding: 10px;\n']);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Dropdown } from 'reactstrap';
import MediaQuery from 'react-responsive';

import Avatar from './Avatar';
import { DropdownToggle, MemberActions, MemberName, SignedInBox, DropDown as DropDownMenu } from './pieces';
import MemberTypeBadge from '../MemberTypeBadge';
import MenuList from './MenuList';
import { capitalize } from '../utils/string';
import HeaderMailModal from '../HeaderMailModal';

var AngleDown = styled.i.attrs({
  className: 'fa fa-angle-down'
})(_templateObject);
var StyledDropdown = styled(Dropdown)(_templateObject2);

export var LoggedInUserBox = function LoggedInUserBox(_ref) {
  var me = _ref.me,
      options = _ref.options,
      comp = _ref.comp;
  return React.createElement(
    MemberActions,
    null,
    React.createElement(Avatar, { src: me && me.photo }),
    React.createElement(
      MediaQuery,
      { minWidth: 1200 },
      React.createElement(
        SignedInBox,
        null,
        React.createElement(
          MemberName,
          null,
          capitalize(me.firstName),
          React.createElement(
            MediaQuery,
            { minWidth: 992 },
            React.createElement(AngleDown, null)
          )
        ),
        me.type ? React.createElement(MemberTypeBadge, { type: me.type, memberClass: me.class }) : null,
        options ? React.createElement(MenuList, { options: options, comp: comp }) : null
      )
    )
  );
};

export var MemberDropdown = function (_React$Component) {
  _inherits(MemberDropdown, _React$Component);

  function MemberDropdown(props) {
    _classCallCheck(this, MemberDropdown);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.state = {
      dropdownOpen: false,
      modalOpen: false,
      modalType: null
    };
    _this.toggle = _this.toggle.bind(_this);
    _this.modalToggle = _this.modalToggle.bind(_this);
    _this.setModalType = _this.setModalType.bind(_this);
    return _this;
  }

  MemberDropdown.prototype.toggle = function toggle() {
    this.setState(function (prevState) {
      return {
        dropdownOpen: !prevState.dropdownOpen
      };
    });
  };

  MemberDropdown.prototype.modalToggle = function modalToggle() {
    this.setState({ modalOpen: !this.state.modalOpen });
  };

  MemberDropdown.prototype.setModalType = function setModalType(modalType) {
    this.setState({ modalType: modalType });
  };

  MemberDropdown.prototype.render = function render() {
    var _state = this.state,
        dropdownOpen = _state.dropdownOpen,
        modalOpen = _state.modalOpen,
        modalType = _state.modalType;
    var _props = this.props,
        me = _props.me,
        loading = _props.loading,
        options = _props.options,
        comp = _props.comp,
        _props$meEmailMigrati = _props.meEmailMigrationData,
        meEmailMigrationData = _props$meEmailMigrati === undefined ? {} : _props$meEmailMigrati,
        onToggleDoNotShowAgain = _props.onToggleDoNotShowAgain;

    if (loading) {
      return React.createElement(
        'p',
        null,
        'Loading'
      );
    }
    return React.createElement(
      StyledDropdown,
      { isOpen: dropdownOpen, toggle: this.toggle, direction: 'down' },
      React.createElement(
        DropdownToggle,
        { tag: 'div' },
        React.createElement(LoggedInUserBox, { me: me })
      ),
      React.createElement(HeaderMailModal, { open: modalOpen, onToggle: this.modalToggle, type: modalType, meEmailMigrationData: meEmailMigrationData, onToggleDoNotShowAgain: onToggleDoNotShowAgain, me: me }),
      React.createElement(DropDownMenu, { options: options, comp: comp, modalToggle: this.modalToggle, meEmailMigrationData: meEmailMigrationData, setModalType: this.setModalType, me: me })
    );
  };

  return MemberDropdown;
}(React.Component);

export var MobileTopMenu = function MobileTopMenu(_ref2) {
  var me = _ref2.me,
      menuOptions = _ref2.menuOptions,
      comp = _ref2.comp;
  return me ? React.createElement(LoggedInUserBox, { me: me, options: menuOptions, comp: comp }) : null;
};

MemberDropdown.propTypes = process.env.NODE_ENV !== "production" ? {
  me: PropTypes.object,
  loading: PropTypes.bool,
  options: PropTypes.array.isRequired,
  comp: PropTypes.func
} : {};

export default MemberDropdown;